/* BAKAMI · carosello immagini nelle card prodotto
   Scroll-snap nativo (swipe su touch) + frecce e puntini sincronizzati. */
if (!customElements.get('bk-card-slider')) {
  class BkCardSlider extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.bk-cslider__track');
      this.slides = Array.from(this.querySelectorAll('.bk-cslider__slide'));
      this.dots = Array.from(this.querySelectorAll('.bk-cslider__dot'));
      this.prev = this.querySelector('.bk-cslider__btn--prev');
      this.next = this.querySelector('.bk-cslider__btn--next');
      if (!this.track || this.slides.length < 2) return;

      this.prev.addEventListener('click', (e) => this.go(e, -1));
      this.next.addEventListener('click', (e) => this.go(e, 1));
      this.track.addEventListener('scroll', () => {
        cancelAnimationFrame(this.raf);
        this.raf = requestAnimationFrame(() => this.update());
      }, { passive: true });
      this.update();
    }

    index() {
      const w = this.track.clientWidth || 1;
      return Math.max(0, Math.min(this.slides.length - 1, Math.round(this.track.scrollLeft / w)));
    }

    go(event, dir) {
      event.preventDefault();
      event.stopPropagation();
      const i = Math.max(0, Math.min(this.slides.length - 1, this.index() + dir));
      this.track.scrollTo({ left: i * this.track.clientWidth, behavior: 'smooth' });
    }

    update() {
      const i = this.index();
      this.dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
      this.slides.forEach((s, n) => (n === i ? s.removeAttribute('aria-hidden') : s.setAttribute('aria-hidden', 'true')));
      this.prev.disabled = i === 0;
      this.next.disabled = i === this.slides.length - 1;
    }
  }
  customElements.define('bk-card-slider', BkCardSlider);
}
